var home = function () {

    function pageBodyLoad() {
        showSpinner();
        checkUserStatus();
    }

    function checkUserStatus() {
        let method, url, input;

        method = "GET";
        url = "../api/user/user_actions.php?action=check_user";

        const checkUserStatusSuccess = function (response) {
            getUserStatusLoad(JSON.parse(response));
        }

        const checkUserStatusError = function () {
            var response = {
                "logged_in": false,
                "message": "Could not check user status"
            }
            getUserStatusLoad(response);
        }

        coreFunctions.xhrHelper(method, url, checkUserStatusSuccess, checkUserStatusError, input);
    }

    let checkUserResponse;

    function getUserStatusLoad(response) {
        // Valid user
        if (response.logged_in == true) {

            checkUserResponse = response;

            // New user, prompt to update login details
            if (response.new_user != "false") {
                newUserMessage.classList.remove("hidden");
                showOverlay("management");
            } else {
                coreFunctions.userguidingSetup(response);
            }
            updateHomepage(response.user_details);
            companyLists.getRecentCompanyLists();
        }
        //
        else {
            requireLogin();
        }
    }

    function setupUserguiding() {
        if (checkUserResponse) {
            coreFunctions.userguidingSetup(checkUserResponse);
            checkUserResponse = false; // Reset variable to prevent multiple calls to userguiding setup
        }
    }

    // Fills in the landing page, with the users details, e.g. expiry date
    function updateHomepage(userdetails) {
        document.getElementById("userFirstname").innerHTML = userdetails.first_name;
        // Show free trial specific content
        if (userdetails.trial_user) {
            document.body.classList.add("trialAccount");
        }
    }

    function findCompany() {
        var searchString = document.getElementById("findCompanyInput").value;
        var url = urlPath + "/explore?searchstring=" + encodeURI(searchString.trim());
        window.open(url, "_self");
    }

    function showSpinner() {
        let spinner = document.getElementById("spinner");
        spinner.classList.add("spinnerVisible");
        document.getElementById("spinnerHolder").classList.add("active");
        spinner.style.display = "block";
        setTimeout(function () {
            spinner.style.opacity = "1";
        }, 100);
    }

    function hideSpinner() {
        let spinner = document.getElementById("spinner");
        spinner.style.opacity = "0";
        setTimeout(function () {
            document.getElementById("spinnerHolder").classList.remove("active");
            spinner.style.display = "none";
            spinner.classList.remove("spinnerVisible");
        }, 400);
    }

    function loadingComplete() {
        hideSpinner();
        setTimeout(function () {
            document.getElementById("main").classList.remove("mainHidden");
        }, 500);
    }

    function toggleBoxView(element) {
        let box, boxContent;
        if (box = element.closest(".box")) {
            box.classList.toggle("boxContentCollapsed");
        }
    }

    class CompanyLists {
        constructor() {
            this.lists = [];
            this.folders = new Folders();
        }

        newCompanyList(listID, title, notes, returnCount, created, edited, folderID, version, trainingIncludeTotalCompanies, trainingExcludeTotalCompanies, folderName) {
            const companyList = new CompanyList(listID, title, notes, returnCount, created, edited, folderID, version, trainingIncludeTotalCompanies, trainingExcludeTotalCompanies, folderName);
            this.lists.push(companyList);
            return companyList;
        }

        getRecentCompanyLists() {
            let method, url;
            const companyListsObject = this;

            method = "GET";
            url = "../api/lists/lists_actions.php?action=get_recent_ml_lists";

            const getRecentCompanyListsSuccess = function (responseText) {
                const response = JSON.parse(responseText);
                if (response.status == "success") {
                    response.companies_lists.forEach(list => companyListsObject.newCompanyList(list.list_id, list.title, list.notes, list.return_count, list.created, list.edited, list.folder_id, list.version, list.trainingCompanies.include.length, list.trainingCompanies.exclude.length, list.folder_name));
                }
                companyListsObject.addListElementsToPage();
                companyListsObject.folders.getFolders();
            }

            const getRecentCompanyListsError = function () {
                companyListsObject.folders.getFolders();
            }

            coreFunctions.xhrHelper(method, url, getRecentCompanyListsSuccess, getRecentCompanyListsError);
        }

        addListElementsToPage() {
            if (this.lists.length > 0) {
                this.lists.forEach(list => list.addListElementToPage());
            } else {
                // No saved lists
                document.getElementById("recentListsHolder").appendChild(coreFunctions.createElementHelper("p", { class: "noRecent", innerHTML: "You do not currently have any company lists." }));
            }
        }

        editList(form) {
            let input, method, url;
            const listsObject = this;

            document.getElementById("editListSubmitButton").disabled = true;

            input = new FormData(form);
            method = "POST";
            url = `../api/ml_list/ml_list_actions.php?action=editlist&listid=${form.elements.listID.value}`;

            const editListSuccess = function (responseText) {
                const response = JSON.parse(responseText);
                if (response.status == "success") {
                    listsObject.lists.find(list => list.listID == response.listID).editListLoad(response);
                } else {
                    listsObject.editListError(response);
                }
            }

            const editListError = function () {
                const response = {
                    status: "error",
                    title: "Error",
                    message: "Could not edit company list."
                }
                listsObject.editListError(response);
            }

            coreFunctions.xhrHelper(method, url, editListSuccess, editListError, input);
        }

        editListError(response) {
            // Remove in progress class from button
            document.getElementById("editListSubmitButton").disabled = false;

            if (response.input_error && response.input_error.length > 0) {
                // Update page with any input errors
                document.querySelector("#editListForm .input_error").innerHTML = response.input_error;
            } else {
                // Hide form and display error message
                coreFunctions.hideOverlay(document.getElementById("editListForm"));
                coreFunctions.showStatusMessage(response.title, response.message);
            }
        }

        clearEditListInputError() {
            document.querySelector("#editListForm .input_error").innerHTML = "&nbsp;";
        }

        editListNotes(form) {
            let input, method, url;
            const mlListObject = this;

            document.getElementById("notesListSubmitButton").disabled = true;

            input = new FormData(form);
            method = "POST";
            url = `../api/ml_list/ml_list_actions.php?action=notes&listid=${form.elements.listID.value}`;

            const notesListSuccess = function (responseText) {
                const response = JSON.parse(responseText);
                if (response.status == "success") {
                    document.getElementById("notesListSubmitButton").disabled = false;

                    // Update the notes with the filtered response
                    document.querySelector("#notesListForm textarea[name='notes']").value = response.notes;
                    mlListObject.lists.find(list => list.listID == response.listID).notes = response.notes;

                    // Hide form and display success message
                    coreFunctions.hideOverlay(document.getElementById("notesListForm"));
                    coreFunctions.showStatusMessage(response.title, response.message);
                } else {
                    mlListObject.editListError(response);
                }
            }

            const notesListError = function () {
                const response = {
                    status: "error",
                    title: "Error",
                    message: "Could not edit company list."
                }
                mlListObject.editListNotesError(response);
            }

            coreFunctions.xhrHelper(method, url, notesListSuccess, notesListError, input);
        }

        editListNotesError(response) {
            // Remove in progress class from button
            document.getElementById("notesListSubmitButton").disabled = false;

            if (response.input_error && response.input_error.length > 0) {
                // Update page with any input errors
                document.querySelector("#notesListForm .input_error").innerHTML = response.input_error;
            } else {
                // Hide form and display error message
                coreFunctions.hideOverlay(document.getElementById("notesListForm"));
                coreFunctions.showStatusMessage(response.title, response.message);
            }
        }

        clearNotesListInputError() {
            document.querySelector("#notesListForm .input_error").innerHTML = "&nbsp;";
        }

        moveList(form) {
            let input, method, url;
            const listsObject = this;

            document.getElementById("moveListButton").disabled = true;

            input = new FormData(form);
            method = "POST";
            url = `../api/ml_list/ml_list_actions.php?action=move_ml_list&listid=${form.elements.listID.value}`;

            const moveListSuccess = function (responseText) {
                const response = JSON.parse(responseText);
                if (response.status == "success") {
                    listsObject.lists.find(list => list.listID == response.listID).moveListLoad(response);
                } else {
                    listsObject.moveListError(response);
                }
            }

            const moveListError = function () {
                const response = {
                    status: "error",
                    title: "Error",
                    message: "Could not move list."
                };
                listsObject.moveListError(response);
            }

            coreFunctions.xhrHelper(method, url, moveListSuccess, moveListError, input);

        }

        moveListError(response) {
            document.getElementById("moveListButton").disabled = false;
            coreFunctions.hideOverlay(document.getElementById("moveListButton"));
            coreFunctions.showStatusMessage(response.title, response.message);
        }

        shareList(form) {
            let input, method, url;
            const listsObject = this;

            document.getElementById("shareListButton").disabled = true;

            input = new FormData(form);
            method = "POST";
            url = `../api/ml_list/ml_list_actions.php?action=sharelist&listid=${form.elements.listID.value}`;

            const shareListSuccess = function (responseText) {
                const response = JSON.parse(responseText);
                listsObject.shareListLoad(response);
            }

            const shareListError = function () {
                const response = {
                    status: "error",
                    input_errors: {
                        email: "&nbsp;",
                        general: "Could not share list. An unexpected error occurred. Please try again."
                    }
                }
                listsObject.shareListLoad(response);
            }

            coreFunctions.xhrHelper(method, url, shareListSuccess, shareListError, input);

        }

        shareListLoad(response) {
            document.getElementById("shareListButton").disabled = false;
            if (response.status == "success") {
                coreFunctions.hideOverlay(document.getElementById("shareListButton"));
                coreFunctions.showStatusMessage("Share success", `The "${response.list_title}" list has been shared with user ${response.share_email}`);
            }
            document.querySelector("#shareListForm .input_error[field='email']").innerHTML = response.input_errors.email;
            document.querySelector("#shareListForm .input_error[field='general']").innerHTML = response.input_errors.general;
        }

        resetShareListInputErrors() {
            document.querySelector("#shareListForm .input_error[field='email']").innerHTML = "&nbsp;";
            document.querySelector("#shareListForm .input_error[field='general']").innerHTML = "&nbsp;";
        }

        copyList(form) {
            let input, method, url;
            const listsObject = this;

            document.getElementById("copyListButton").disabled = true;

            input = new FormData(form);
            method = "POST";
            url = `../api/ml_list/ml_list_actions.php?action=copy_ml_list&listid=${form.elements.listID.value}`;

            const copyListSuccess = function (responseText) {
                const response = JSON.parse(responseText);
                listsObject.copyListLoad(response);
            }

            const copyListError = function () {
                const response = {
                    status: "error",
                    title: "List copy error",
                    message: "Sorry, your list could not be copied at this time."
                }
                listsObject.copyListLoad(response);
            }

            coreFunctions.xhrHelper(method, url, copyListSuccess, copyListError, input);

        }

        copyListLoad(response) {
            let copiedListDetails;
            document.getElementById("copyListButton").disabled = false;
            if (response.status == "success") {
                copiedListDetails = response.listDetails;
                this.newCompanyList(copiedListDetails.listID, copiedListDetails.title, '', copiedListDetails.returnCount, copiedListDetails.created, copiedListDetails.edited, copiedListDetails.folderID, copiedListDetails.version, copiedListDetails.trainingIncludeTotalCompanies, copiedListDetails.trainingExcludeTotalCompanies).addListElementToPage(true);
            }
            coreFunctions.hideOverlay(document.getElementById("copyListButton"));
            coreFunctions.showStatusMessage(response.title, response.message);
        }

        deleteCompanyList(form) {
            let input, method, url;
            const listsObject = this;

            document.getElementById("deleteListButton").disabled = true;

            input = new FormData(form);
            method = "POST";
            url = `../api/ml_list/ml_list_actions.php?action=delete_ml_list&listid=${form.elements.listID.value}`;

            const deleteListSuccess = function (responseText) {
                const response = JSON.parse(responseText);
                listsObject.deleteCompanyListLoad(response);
            }

            const deleteListError = function () {
                const response = {
                    status: "error",
                    title: "List delete error",
                    message: "Sorry, your list could not be deleted at this time."
                }
                listsObject.deleteCompanyListLoad(response);
            }

            coreFunctions.xhrHelper(method, url, deleteListSuccess, deleteListError, input);
        }

        deleteCompanyListLoad(response) {
            document.getElementById("deleteListButton").disabled = false;
            if (response.status == "success") {
                this.lists.find(list => list.listID == response.listID).deleteListControlElementFromPage();
            }
            coreFunctions.hideOverlay(document.getElementById("deleteListButton"));
            coreFunctions.showStatusMessage(response.title, response.message);
        }
    }

    class CompanyList {
        constructor(listID, title, notes, returnCount, created, edited, folderID, version, trainingIncludeTotalCompanies, trainingExcludeTotalCompanies, folderName) {
            this.listID = listID;
            this.title = title;
            this.notes = notes;
            this.returnCount = returnCount;
            this.created = created;
            this.edited = edited;
            this.folderID = folderID;
            this.version = version;
            this.currentProductVersion = "2.0";
            this.trainingIncludeTotalCompanies = trainingIncludeTotalCompanies;
            this.trainingExcludeTotalCompanies = trainingExcludeTotalCompanies;
            this.folderName = folderName;
        }

        checkListBuiltWithCurrentVersion() {
            return this.version == this.currentProductVersion;
        }

        addListElementToPage(copiedList) {
            let existingList, actionsHolder, listDetailsElement, listBuiltWithCurrentVersion, listActionsControlLabel, moreDetailsControlHolder, accordianListElementMain;
            const listObject = this;

            listBuiltWithCurrentVersion = this.checkListBuiltWithCurrentVersion();

            existingList = coreFunctions.createElementHelper("li", { class: "existingList", list_id: this.listID });

            accordianListElementMain = existingList.appendChild(coreFunctions.createElementHelper("div", {class: "accordian-list-main"}));

            moreDetailsControlHolder = accordianListElementMain.appendChild(coreFunctions.createElementHelper("div", { class: "accordian-control-holder" }));

            moreDetailsControlHolder.appendChild(coreFunctions.createElementHelper("button", { class: "actionControl extraDetailsButton", innerHTML: "&nbsp;" }, { click: function () { listObject.extraDetailsButtonClick(this) } }))

            listDetailsElement = accordianListElementMain.appendChild(coreFunctions.createElementHelper("div", { class: "accordian-list-name listDetailsElement" }));

            actionsHolder = accordianListElementMain.appendChild(coreFunctions.createElementHelper("div", { class: "accordian-control-holder actionsHolder" }));

            listDetailsElement.appendChild(coreFunctions.createElementHelper("a", { class: "existingListName", href: `${urlPath}/ml_list?list_id=${this.listID}${(listBuiltWithCurrentVersion) ? "" : "&legacylist=true"}`, innerHTML: `${this.title}${(copiedList) ? " <strong>*New</strong>" : ""}${(listBuiltWithCurrentVersion) ? `<span class='formattedVersion'></span>` : ""}` }));

            existingList.appendChild(this.addListExtraDetails());

            // Only add controls for lists made in the current version
            if (listBuiltWithCurrentVersion) {
                actionsHolder.appendChild(coreFunctions.createElementHelper("input", { class: "listActionsControl", type: "checkbox", id: `listActionsControl-${this.listID}` }, {change: function() {listObject.listActionsControlOnChange(this);}}));

                listActionsControlLabel = actionsHolder.appendChild(coreFunctions.createElementHelper("label", { class: "listActionsControlLabel", for: `listActionsControl-${this.listID}` }));

                listActionsControlLabel.appendChild(coreFunctions.createElementHelper("span", { "class": "controlsToggle", innerHTML: "&nbsp;" }));

                listActionsControlLabel.appendChild(this.createListActionsControls());
            }

            if (copiedList) {
                document.getElementById("recentListsHolder").insertBefore(existingList, document.getElementById("recentListsHolder").firstElementChild)
            } else {
                document.getElementById("recentListsHolder").appendChild(existingList);
            }
        }

        listActionsControlOnChange(element) {
            let activeActionTab
            if (activeActionTab = document.querySelector(`#recentListsHolder input.listActionsControl:not(#${element.id}):checked`)) {
                activeActionTab.checked = false;
            }
        }

        createListActionsControls() {
            let actionsHolder;
            const listObject = this;

            actionsHolder = coreFunctions.createElementHelper("span", { class: "controls" });

            actionsHolder.appendChild(coreFunctions.createElementHelper("button", { innerHTML: "<span>Edit name</span>", class: "actionControl edit-list", title: "Edit list" }, { click: function () { listObject.updateEditListOverlay() } }));

            actionsHolder.appendChild(coreFunctions.createElementHelper("button", { innerHTML: "<span>Notes</span>", class: "actionControl list-notes", title: "Edit notes" }, { click: function () { listObject.updateNotesListOverlay() } }));

            actionsHolder.appendChild(coreFunctions.createElementHelper("button", { innerHTML: "<span>Make a copy</span>", title: "Copy list", class: "actionControl copy-list" }, { click: function () { listObject.copyListControlAction() } }));

            actionsHolder.appendChild(coreFunctions.createElementHelper("button", { innerHTML: "<span>Move</span>", title: "Move list", class: "actionControl move-list" }, { click: function () { listObject.moveListControlAction() } }));

            actionsHolder.appendChild(coreFunctions.createElementHelper("button", { innerHTML: "<span>Share</span>", title: "Share list", class: "actionControl share-list" }, { click: function () { listObject.shareListControlAction() } }));

            actionsHolder.appendChild(coreFunctions.createElementHelper("button", { innerHTML: "<span>Delete</span>", title: "Delete list", class: "actionControl delete-list" }, { click: function () { listObject.deleteCompanyListButtonClick() } }));

            return actionsHolder;
        }

        updateEditListOverlay() {
            // Hide previous input errors
            companyLists.clearEditListInputError();
            document.querySelector("#editListForm input[name='listID']").value = this.listID;
            document.querySelector("#editListForm input[name='title']").value = this.title;
            coreFunctions.showOverlay("editlist");
        }

        updateNotesListOverlay() {
            // Hide previous input errors
            companyLists.clearNotesListInputError();
            document.querySelector("#notesListForm input[name='listID']").value = this.listID;
            document.querySelector("#notesListForm textarea[name='notes']").value = this.notes;
            coreFunctions.showOverlay("noteslist");
        }

        editListLoad(response) {
            // Remove in progress class from button
            document.getElementById("editListSubmitButton").disabled = false;

            this.title = response.listTitle;
            // Update title on select page with new text
            document.querySelector(`#recentListsHolder .existingList[list_id='${this.listID}'] .existingListName span`).innerHTML = this.title;
            // Hide form and display success message
            coreFunctions.hideOverlay(document.getElementById("editListForm"));
            coreFunctions.showStatusMessage(response.title, response.message);

        }

        copyListControlAction() {
            document.getElementById("listToCopyTitle").innerHTML = this.title;
            document.querySelector("#copyListForm input[name='copyListTitle']").value = `${this.title} copy`;
            document.querySelector("#copyListForm input[name='listID']").value = this.listID;
            coreFunctions.showOverlay("copylist");
        }

        moveListControlAction() {
            document.querySelector("#moveListForm input[name='listID']").value = this.listID;
            // See if the folders list is active
            if (document.getElementById("moveListFolders").querySelector(`option[value='${this.folderID}']`)) {
                // Set to current value
                document.getElementById("moveListFolders").value = this.folderID;
            }
            // Otherwise set to the default all value
            else {
                document.getElementById("moveListFolders").value = "all";
            }
            // Add title and add to control box
            document.getElementById("listToMoveTitle").innerHTML = this.title;
            coreFunctions.showOverlay("movelist");
        }

        moveListLoad(response) {
            this.folderID = response.folderID;
            document.getElementById("moveListButton").disabled = false;
            coreFunctions.hideOverlay(document.getElementById("moveListButton"));
            coreFunctions.showStatusMessage(response.title, response.message);
        }

        shareListControlAction() {
            document.querySelector("#shareListForm input[name='shareUserEmail']").value = null;
            document.querySelector("#shareListForm input[name='listID']").value = this.listID;
            companyLists.resetShareListInputErrors();

            // Add title and add to control box
            document.getElementById("listToShareTitle").innerHTML = this.title;
            coreFunctions.showOverlay("sharelist");
        }

        deleteCompanyListButtonClick() {
            document.getElementById("companyListDeleteWarningTitle").innerHTML = `Confirm "${this.title}" deletion`;
            document.querySelector("#deleteListForm input[name='listID']").value = this.listID;
            document.querySelector("#deleteListForm input[name='title']").value = this.title;
            coreFunctions.showOverlay("deletelistpanel");
        }

        deleteListControlElementFromPage() {
            document.getElementById("recentListsHolder").removeChild(document.querySelector(`#recentListsHolder .existingList[list_id='${this.listID}']`));
        }

        addListExtraDetails() {
            let extraDetailsHolder = coreFunctions.createElementHelper("ul", { class: "extraDetailsHolder accordian-list-details" });

            extraDetailsHolder.appendChild(coreFunctions.createElementHelper("li", { innerHTML: `<div class='label'>Created</div><div class='field'>${moment(this.created, "YYYY-MM-DD").format("DD/MM/YY")}</div>` }));

            extraDetailsHolder.appendChild(coreFunctions.createElementHelper("li", { innerHTML: `<div class='label'>Last edited</div><div class='field'>${moment(this.edited, "YYYY-MM-DD HH:mm:ss").format("HH:mm DD/MM/YY")}</div>` }));

            extraDetailsHolder.appendChild(coreFunctions.createElementHelper("li", { innerHTML: `<div class='label'>Training set</div><div class='field'>Include: <span class='green'>${this.trainingIncludeTotalCompanies}</span> | Exclude: <span class='orange'>${this.trainingExcludeTotalCompanies}</span></div>` }));

            extraDetailsHolder.appendChild(coreFunctions.createElementHelper("li", { innerHTML: `<div class='label'>Folder</div><div class='field'><a class='folderLink' href='${(this.folderID) ? `${urlPath}/listsfolder?folder_id=${this.folderID}&folder_name=${this.folderName}` : `${urlPath}/listsfolder?folder_id=all`}' target='_blank'>${(this.folderName) ? this.folderName : "All company lists"}<a></div>` })); // Folder link

            return extraDetailsHolder;
        }

        extraDetailsButtonClick(element) {
            let listContent = element.closest(".existingList");
            console.log(listContent);
            if (listContent.classList.contains("extraDetailsVisible")) {
                listContent.classList.remove("extraDetailsVisible");
            } else {
                listContent.classList.add("extraDetailsVisible");
            }
        }
    }

    class Folders {
        constructor() {
            this.folders = [];
        }

        getFolders() {
            let method, url;
            const foldersObject = this;

            method = "GET";
            url = "../api/lists/lists_actions.php?action=get_ml_list_folders";

            const getFoldersSuccess = function (responseText) {
                const response = JSON.parse(responseText)
                if (response.status == "success") {
                    response.folders.forEach(folder => foldersObject.newFolder(folder.folder_id, folder.folder_name));
                    foldersObject.addFoldersToPage();
                    exploreLists.getExploreLists();
                }
            }

            const getFoldersError = function () {
                console.log("Error getting folders");
                exploreLists.getExploreLists();
            }

            coreFunctions.xhrHelper(method, url, getFoldersSuccess, getFoldersError);
        }

        newFolder(folderID, name) {
            const folder = new Folder(folderID, name);
            this.folders.push(folder);
            return folder;
        }

        addFoldersToPage() {
            this.folders.forEach((folder) => folder.addFolderToMoveListSelect());
        }

    }

    class Folder {
        constructor(folderID, name) {
            this.folderID = folderID;
            this.name = name;
            this.folderElementsInTopLevel = 6;
        }

        addFolderToMoveListSelect() {
            document.getElementById("moveListFolders").appendChild(coreFunctions.createElementHelper("option", { value: this.folderID, innerHTML: this.name }));
            return this;
        }
    }

    class ExploreLists {
        constructor() {
            this.exploreLists = [];
        }

        getExploreLists() {
            let method, url;
            const exploreListsObject = this;

            method = "POST";
            url = `../api/lists/lists_actions.php?action=recentexplorelists`;

            const getExploreListsSuccess = function (responseText) {
                const response = JSON.parse(responseText);
                if (response.status == "success") {
                    response.exploreLists.forEach(list => exploreListsObject.newExploreList(list.listID, list.listName, list.notes, list.listCreated, list.listEdited));
                    exploreListsObject.addListElementsToPage();
                }
                rtics.getRecentRtics();
            }

            const getExploreListsError = function () {
                console.log("Error obtaining explore lists");
                rtics.getRecentRtics();
            }

            coreFunctions.xhrHelper(method, url, getExploreListsSuccess, getExploreListsError);
        }

        newExploreList(listID, name, notes, created, edited) {
            const exploreList = new ExploreList(listID, name, notes, created, edited);
            this.exploreLists.push(exploreList);
            return exploreList;
        }

        addListElementsToPage() {
            if (this.exploreLists.length > 0) {
                this.exploreLists.forEach(list => list.addListElementToPage());
            } else {
                this.noExploreLists();
            }
            return this
        }

        noExploreLists() {
            // No saved lists
            document.getElementById("recentExploreListsHolder").appendChild(coreFunctions.createElementHelper("p", { class: "noRecent", innerHTML: "You do not currently have any saved Explore lists." }));
            return this;
        }

        editExploreList(form) {
            let input, method, url;
            const exploreListsObject = this;

            document.getElementById("editExploreListSubmitButton").disabled = true;

            input = new FormData(form);
            method = "POST";
            url = `../api/explore/explore_actions.php?action=edit&listid=${Number(input.get('listID'))}`;

            const editExploreListSuccess = function (responseText) {
                const response = JSON.parse(responseText);
                if (response.status == "success") {
                    exploreListsObject.exploreLists.find(list => list.listID == response.listID).editExploreListLoad(response);
                } else {
                    exploreListsObject.editListError(response);
                }
            }

            const editExploreListError = function () {
                const response = {
                    status: "error",
                    title: "Error",
                    message: "Could not edit explore list."
                }
                exploreListsObject.editListError(response);
            }

            coreFunctions.xhrHelper(method, url, editExploreListSuccess, editExploreListError, input);
        }

        editListError(response) {
            // Remove in progress class from button
            document.getElementById("editListSubmitButton").disabled = false;

            if (response.input_error && response.input_error.length > 0) {
                // Update page with any input errors
                document.querySelector("#editListForm .input_error").innerHTML = response.input_error;
            } else {
                // Hide form and display error message
                coreFunctions.hideOverlay(document.getElementById("editListForm"));
                coreFunctions.showStatusMessage(response.title, response.message);
            }
        }

        clearEditExploreListInputError() {
            document.querySelector("#editExploreListForm .input_error").innerHTML = "&nbsp;";
        }

        editExploreListNotes(form) {
            let input, method, url;
            const exploreListsObject = this;

            document.getElementById("notesExploreListSubmitButton").disabled = true;

            input = new FormData(form);
            method = "POST";
            url = `../api/explore/explore_actions.php?action=notes&listid=${Number(input.get('listID'))}`;

            const notesExploreListSuccess = function (responseText) {
                const response = JSON.parse(responseText);
                if (response.status == "success") {
                    document.getElementById("notesExploreListSubmitButton").disabled = false;

                    // Update the notes with the filtered response
                    document.querySelector("#notesExploreListForm textarea[name='notes']").value = response.notes;
                    exploreListsObject.exploreLists.find(list => list.listID == response.listID).notes = response.notes;

                    // Hide form and display success message
                    coreFunctions.hideOverlay(document.getElementById("notesExploreListForm"));
                    coreFunctions.showStatusMessage(response.title, response.message);
                } else {
                    exploreListsObject.editListError(response);
                }
            }

            const notesExploreListError = function () {
                const response = {
                    status: "error",
                    title: "Error",
                    message: "Could not edit explore list."
                }
                exploreListsObject.editListNotesError(response);
            }

            coreFunctions.xhrHelper(method, url, notesExploreListSuccess, notesExploreListError, input);
        }

        editListNotesError(response) {
            // Remove in progress class from button
            document.getElementById("notesExploreListSubmitButton").disabled = false;

            if (response.input_error && response.input_error.length > 0) {
                // Update page with any input errors
                document.querySelector("#notesExploreListForm .input_error").innerHTML = response.input_error;
            } else {
                // Hide form and display error message
                coreFunctions.hideOverlay(document.getElementById("notesExploreListForm"));
                coreFunctions.showStatusMessage(response.title, response.message);
            }
        }

        clearNotesExploreListInputError() {
            document.querySelector("#notesExploreListForm .input_error").innerHTML = "&nbsp;";
        }

        copyExploreList(form) {
            let input, method, url;
            const listsObject = this;

            document.getElementById("copyExploreListButton").disabled = true;

            input = new FormData(form);
            method = "POST";
            url = `../api/explore/explore_actions.php?action=copy&listid=${Number(input.get('listID'))}`;

            const copyExploreListSuccess = function (responseText) {
                const response = JSON.parse(responseText);
                listsObject.copyExploreListLoad(response);
            }

            const copyExploreListError = function () {
                const response = {
                    status: "error",
                    title: "List copy error",
                    message: "Sorry, your list could not be copied at this time."
                }
                listsObject.copyExploreListLoad(response);
            }

            coreFunctions.xhrHelper(method, url, copyExploreListSuccess, copyExploreListError, input);

        }

        copyExploreListLoad(response) {
            document.getElementById("copyExploreListButton").disabled = false;
            if (response.status == "success") {
                this.newExploreList(response.listID, response.listName, '', response.listCreated, response.listEdited).addListElementToPage(true);
            }
            coreFunctions.hideOverlay(document.getElementById("copyExploreListButton"));
            coreFunctions.showStatusMessage(response.title, response.message);
        }

        deleteExploreList(form) {
            let input, method, url;
            const listsObject = this;

            document.getElementById("deleteExploreListButton").disabled = true;

            input = new FormData(form);
            method = "POST";
            url = `../api/explore/explore_actions.php?action=delete&listid=${Number(input.get('listID'))}`;

            const deleteExploreListSuccess = function (responseText) {
                const response = JSON.parse(responseText);
                listsObject.deleteExploreListLoad(response);
            }

            const deleteExploreListError = function () {
                const response = {
                    status: "error",
                    "title": "Error",
                    "message": "Sorry, could not delete Explore list."
                }
                listsObject.deleteExploreListLoad(response);
            }

            coreFunctions.xhrHelper(method, url, deleteExploreListSuccess, deleteExploreListError, input);

        }

        deleteExploreListLoad(response) {
            document.getElementById("deleteExploreListButton").disabled = false;

            if (response.status == "success") {
                this.exploreLists.find(list => list.listID == response.listID).deleteExploreListControlElementFromPage();
            }

            coreFunctions.hideOverlay(document.getElementById("deleteExploreListButton"));
            coreFunctions.showStatusMessage(response.title, response.message);
        }

        shareExploreList(form) {
            let input, method, url;
            const listsObject = this;

            document.getElementById("shareExploreListButton").disabled = true;

            input = new FormData(form);
            method = "POST";
            url = `../api/explore/explore_actions.php?action=share&listid=${Number(input.get('listID'))}`;

            const shareExploreListSuccess = function (responseText) {
                const response = JSON.parse(responseText);
                listsObject.shareExploreListLoad(response);
            }

            const shareExploreListError = function () {
                const response = {
                    status: "error",
                    input_errors: {
                        email: "&nbsp;",
                        general: "Could not share list. An unexpected error occurred. Please try again."
                    }
                }
                listsObject.shareExploreListLoad(response);
            }

            coreFunctions.xhrHelper(method, url, shareExploreListSuccess, shareExploreListError, input);
        }

        // Clear input errors
        resetShareExploreListInputErrors() {
            document.querySelector("#shareExploreListForm .input_error[field='email']").innerHTML = "&nbsp;";
            document.querySelector("#shareExploreListForm .input_error[field='general']").innerHTML = "&nbsp;";
        }

        shareExploreListLoad(response) {
            document.getElementById("shareExploreListButton").disabled = false;
            if (response.status == "success") {
                coreFunctions.hideOverlay(document.getElementById("shareExploreListButton"));
                showStatusMessage(response.title, response.message);
            } else {
                document.querySelector("#shareExploreListForm .input_error[field='email']").innerHTML = response.input_errors.email;
                document.querySelector("#shareExploreListForm .input_error[field='general']").innerHTML = response.input_errors.general;
            }
        }

    }

    class ExploreList {
        constructor(listID, name, notes, created, edited) {
            this.listID = listID;
            this.name = name;
            this.notes = notes;
            this.created = created;
            this.edited = edited;
        }

        addListElementToPage(copiedList) {
            let existingList, actionsHolder, listDetailsElement, listActionsControlLabel, moreDetailsControlHolder, accordianListElementMain;
            const listObject = this;

            existingList = coreFunctions.createElementHelper("li", { class: "existingList", list_id: this.listID });

            accordianListElementMain = existingList.appendChild(coreFunctions.createElementHelper("div", {class: "accordian-list-main"}));

            moreDetailsControlHolder = accordianListElementMain.appendChild(coreFunctions.createElementHelper("div", { class: "accordian-control-holder" }));

            moreDetailsControlHolder.appendChild(coreFunctions.createElementHelper("button", { class: "actionControl extraDetailsButton", innerHTML: "&nbsp;" }, { click: function () { listObject.extraDetailsButtonClick(this) } }))

            listDetailsElement = accordianListElementMain.appendChild(coreFunctions.createElementHelper("div", { class: "accordian-list-name listDetailsElement" }));

            actionsHolder = accordianListElementMain.appendChild(coreFunctions.createElementHelper("div", { class: "accordian-control-holder actionsHolder" }));

            listDetailsElement.appendChild(coreFunctions.createElementHelper("a", { class: "existingListName", href: `${urlPath}/explore?list_id=${this.listID}`, innerHTML: `${this.name}${(copiedList) ? " <strong>*New</strong>" : ""}` }));

            existingList.appendChild(this.addListExtraDetails());

            actionsHolder.appendChild(coreFunctions.createElementHelper("input", { class: "listActionsControl", type: "checkbox", id: `listActionsControl-${this.listID}` }, { change: function () { listObject.listActionsControlOnChange(this); } }));

            listActionsControlLabel = actionsHolder.appendChild(coreFunctions.createElementHelper("label", { class: "listActionsControlLabel", for: `listActionsControl-${this.listID}` }));

            listActionsControlLabel.appendChild(coreFunctions.createElementHelper("span", { "class": "controlsToggle", innerHTML: "&nbsp;" }));

            listActionsControlLabel.appendChild(this.createListActionsControls());

            if (copiedList) {
                document.getElementById("recentExploreListsHolder").insertBefore(existingList, document.getElementById("recentExploreListsHolder").firstElementChild)
            } else {
                document.getElementById("recentExploreListsHolder").appendChild(existingList);
            }
        }

        listActionsControlOnChange(element) {
            let activeActionTab
            if (activeActionTab = document.querySelector(`#recentExploreListsHolder input.listActionsControl:not(#${element.id}):checked`)) {
                activeActionTab.checked = false;
            }
        }

        createListActionsControls() {
            let actionsHolder;
            const listObject = this;

            actionsHolder = coreFunctions.createElementHelper("span", { class: "controls" });

            actionsHolder.appendChild(coreFunctions.createElementHelper("a", { innerHTML: "<span>Analyse</span>", class: "actionControl list-insights", title: "List insights", href: `${urlPath}/analyse?explorelist_id=${this.listID}` }));

            actionsHolder.appendChild(coreFunctions.createElementHelper("button", { innerHTML: "<span>Edit name</span>", class: "actionControl edit-list", title: "Edit list" }, { click: function () { listObject.updateEditExploreListOverlay() } }));

            actionsHolder.appendChild(coreFunctions.createElementHelper("button", { innerHTML: "<span>Notes</span>", class: "actionControl edit-notes", title: "Edit notes" }, { click: function () { listObject.updateEditNotesExploreListOverlay() } }));

            actionsHolder.appendChild(coreFunctions.createElementHelper("button", { innerHTML: "<span>Make a copy</span>", title: "Copy list", class: "actionControl copy-list" }, { click: function () { listObject.copyExploreListControlAction() } }));

            actionsHolder.appendChild(coreFunctions.createElementHelper("button", { innerHTML: "<span>Share</span>", title: "Share list", class: "actionControl share-list" }, { click: function () { listObject.shareListControlAction() } }));

            actionsHolder.appendChild(coreFunctions.createElementHelper("button", { innerHTML: "<span>Delete</span>", title: "Delete list", class: "actionControl delete-list" }, { click: function () { listObject.deleteExploreListButtonClick() } }));

            return actionsHolder;
        }

        addListExtraDetails() {
            let extraDetailsHolder = coreFunctions.createElementHelper("ul", { class: "extraDetailsHolder accordian-list-details" });

            extraDetailsHolder.appendChild(coreFunctions.createElementHelper("li", { innerHTML: `<div class='label'>Created</div><div class='field'>${moment(this.created, "YYYY-MM-DD").format("DD/MM/YY")}</div>` }));

            if (this.edited) {
                extraDetailsHolder.appendChild(coreFunctions.createElementHelper("li", { innerHTML: `<div class='label'>Last edited</div><div class='field'>${moment(this.edited, "YYYY-MM-DD HH:mm:ss").format("HH:mm DD/MM/YY")}</div>` }));
            }

            return extraDetailsHolder;
        }

        extraDetailsButtonClick(element) {
            let listContent = element.closest(".existingList");
            if (listContent.classList.contains("extraDetailsVisible")) {
                listContent.classList.remove("extraDetailsVisible");
            } else {
                listContent.classList.add("extraDetailsVisible");
            }
        }

        updateEditExploreListOverlay() {
            // Hide previous input errors
            exploreLists.clearEditExploreListInputError();
            document.querySelector("#editExploreListForm input[name='listID']").value = this.listID;
            document.querySelector("#editExploreListForm input[name='listName']").value = this.name;
            coreFunctions.showOverlay("editexplorelist");
        }

        updateEditNotesExploreListOverlay() {
            // Hide previous input errors
            exploreLists.clearNotesExploreListInputError();
            document.querySelector("#notesExploreListForm input[name='listID']").value = this.listID;
            document.querySelector("#notesExploreListForm textarea[name='notes']").value = this.notes;
            coreFunctions.showOverlay("notesexplorelist");
        }

        editExploreListLoad(response) {
            // Remove in progress class from button
            document.getElementById("editExploreListSubmitButton").disabled = false;

            this.name = response.listName;
            // Update title on select page with new text
            document.querySelector(`#recentExploreListsHolder .existingList[list_id='${this.listID}'] .existingListName`).innerHTML = this.name;
            // Hide form and display success message
            coreFunctions.hideOverlay(document.getElementById("editExploreListForm"));
            coreFunctions.showStatusMessage(response.title, response.message);

        }

        copyExploreListControlAction() {
            document.getElementById("exploreListToCopyTitle").innerHTML = this.name;
            document.querySelector("#copyExploreListForm input[name='listName']").value = `${this.name} copy`;
            document.querySelector("#copyExploreListForm input[name='listID']").value = this.listID;
            coreFunctions.showOverlay("copyexplorelist");
        }

        deleteExploreListButtonClick() {
            document.getElementById("exploreListDeleteWarningTitle").innerHTML = `Confirm "${this.name}" deletion`;
            document.querySelector("#deleteExploreListForm input[name='listID']").value = this.listID;
            document.querySelector("#deleteExploreListForm input[name='name']").value = this.name;
            coreFunctions.showOverlay("deleteexplorelistpanel");
        }

        deleteExploreListControlElementFromPage() {
            document.getElementById("recentExploreListsHolder").removeChild(document.querySelector(`#recentExploreListsHolder .existingList[list_id='${this.listID}']`));
            if (document.getElementById("recentExploreListsHolder").children.length == 0) {
                exploreLists.noExploreLists();
            }
        }

        shareListControlAction() {
            document.querySelector("#shareExploreListForm input[name='listID']").value = this.listID;
            document.querySelector("#shareExploreListForm input[name='listName']").value = this.name;
            exploreLists.resetShareExploreListInputErrors();
            coreFunctions.showOverlay("shareexplorelist");
        }
    }

    class Rtics {
        constructor() {
            this.rtics = [];
        }

        // Create a new director and save it in the collection
        newRtic(title, subsectors, totalCompanies, revised, locked, created, code, description) {
            let rtic = new Rtic(title, subsectors, totalCompanies, revised, locked, created, code, description);
            this.rtics.push(rtic);
            return rtic;
        }

        getRecentRtics() {
            let method, url, input;
            const rticsObject = this;

            method = "POST";
            url = "../api/rtics/rtics_actions.php?action=recent_rtics";

            const getRticsSuccess = function (response) {
                let getRticsResponse = JSON.parse(response);
                rticsObject.processRtics(getRticsResponse);
                loadingComplete();
            }

            const getRticsError = function (response) {
                console.log("Error retrieving RTIC");
                loadingComplete();
            }

            coreFunctions.xhrHelper(method, url, getRticsSuccess, getRticsError, input);
        }

        processRtics(rtics) {
            const rticsObject = this;
            rtics.forEach(rtic => rticsObject.newRtic(rtic.title, rtic.verticals.map(el => el.name), rtic.companies, rtic.revised, rtic.locked, rtic.created, rtic.code, rtic.description).addRticElementsToPage());
        }

        searchLists() {
            let listSearchString, totalRtics;

            listSearchString = document.getElementById("listSearchInput").value.toLowerCase();
            totalRtics = this.rtics.length;
            for (var i=0; i < totalRtics; i++) {
                this.rtics[i].rticSearch(listSearchString);
            }

            // No lists pass the search criteria
            if (document.querySelector(".existingList:not(.hidden)") == undefined) {
                document.getElementById("listSearchNoResults").classList.remove("hidden");
            } else {
                document.getElementById("listSearchNoResults").classList.add("hidden");
            }
        }

        resetLists() {
            this.rtics.forEach(rtic => rtic.showRticListElement());
        }
    }

    class Rtic {
        constructor(title, subsectors, totalCompanies, revised, locked, created, code, description) {
            this.title = title;
            this.code = code;
            this.subsectors = subsectors;
            this.totalCompanies = totalCompanies;
            this.revised = revised;
            this.created = created;
            this.description = description;
            this.locked = locked;
        }

        addRticElementsToPage() {
            let rticList, actionsHolder, listDetailsElement, extraDetailsHolder, extraReleaseTag, moreDetailsControlHolder, accordianListElementMain;
            const rticsObject = this;

            rticList = coreFunctions.createElementHelper("li", { class: "existingList", rtic_name: this.title });

            accordianListElementMain = rticList.appendChild(coreFunctions.createElementHelper("div", {class: "accordian-list-main"}));

            moreDetailsControlHolder = accordianListElementMain.appendChild(coreFunctions.createElementHelper("div", { class: "accordian-control-holder" }));

            listDetailsElement = accordianListElementMain.appendChild(coreFunctions.createElementHelper("div", { class: "accordian-list-name listDetailsElement" }));

            actionsHolder = accordianListElementMain.appendChild(coreFunctions.createElementHelper("div", {class: "accordian-control-holder  actionsHolder"}));

            moreDetailsControlHolder.appendChild(coreFunctions.createElementHelper("button", {class: "actionControl extraDetailsButton", innerHTML: "&nbsp;"}, {click: function() {rticsObject.extraDetailsButtonClick(this);}})); // Show extra details button

            const rticLink = listDetailsElement.appendChild(coreFunctions.createElementHelper("a", {title: "See full list", class:`existingListName${(this.locked) ? " rticLocked": ""}`, href: `${(this.locked) ? "": `${urlPath}/explore?rtic=${encodeURIComponent(this.code)}`}`, innerHTML: `${this.title}`}));

            if (extraReleaseTag = this.checkRticExtraReleaseTag()) {
                rticLink.appendChild(coreFunctions.createElementHelper("span", {class:"rticReleaseTag", innerHTML: extraReleaseTag}));
            }

            if (this.locked === true) {
                rticLink.appendChild(coreFunctions.createElementHelper("button", {class:"unlock", innerHTML: "subscribe to unlock"}, {click: function() {coreFunctions.subscribeRequest()}}));
            }

            rticLink.appendChild(coreFunctions.createElementHelper("span", {class:"rticCompaniesTotal", innerHTML: `${this.totalCompanies.toLocaleString()} companies`}));

            extraDetailsHolder = rticList.appendChild(coreFunctions.createElementHelper("ul", {class:"extraDetailsHolder accordian-list-details"}));
            extraDetailsHolder.appendChild(coreFunctions.createElementHelper("li", {innerHTML: `<div class='label'>Code</div><div class='field'>${this.code}</div>`}));
            extraDetailsHolder.appendChild(coreFunctions.createElementHelper("li", {innerHTML: `<div class='label'>Created</div><div class='field'>${moment(this.created, "YYYY-MM-DD").format("DD/MM/YY")}</div>`}));
            if (this.revised) {
                extraDetailsHolder.appendChild(coreFunctions.createElementHelper("li", {innerHTML: `<div class='label'>Revised</div><div class='field'>${moment(this.revised, "YYYY-MM-DD").format("DD/MM/YY")}</div>`}));
            }
            extraDetailsHolder.appendChild(coreFunctions.createElementHelper("li", {innerHTML: `<div class='label'>Companies</div><div class='field'>${this.totalCompanies.toLocaleString()}</div>`}));
            extraDetailsHolder.appendChild(coreFunctions.createElementHelper("li", {innerHTML: `<div class='label'>Description</div><div class='field'>${(this.description) ? this.description : "Unavailable"}</div>`}));
            extraDetailsHolder.appendChild(coreFunctions.createElementHelper("li", {innerHTML: `<div class='label'>Verticals</div><div class='field'>${this.subsectors.join(", ")}</div>`}));

            //actionsHolder.appendChild(coreFunctions.createElementHelper("span", {class:"rticCompaniesTotal", innerHTML: `${this.totalCompanies.toLocaleString()} companies`}));
            actionsHolder.appendChild(coreFunctions.createElementHelper("a", {innerHTML: "&nbsp;", title: "See RTIC analysis", class: "rtic_analysis", href: `${urlPath}/analyse?rtic=${this.code}`}));

            document.getElementById("recentRticsHolder").appendChild(rticList);
            return this;
        }

        checkRticExtraReleaseTag() {
            // Created in the last month
            if (moment().diff(moment(this.created, "YYYY-MM-DD"), "months") == 0) {
                return "New";
            }
            // Revised in the last month
            else if (this.revised && moment().diff(moment(this.revised, "YYYY-MM-DD"), "months") == 0) {
                return "Revised";
            } else {
                return false;
            }

        }

        extraDetailsButtonClick(element) {
            let listContent = element.closest(".existingList");
            if (listContent.classList.contains("extraDetailsVisible")) {
                listContent.classList.remove("extraDetailsVisible");
            } else {
                listContent.classList.add("extraDetailsVisible");
            }
        }

        rticSearch(searchString) {
            if (this.title.toLowerCase().includes(searchString)) {
                this.showRticListElement();
            } else {
                this.hideRticLiseElement();
            }
        }

        showRticListElement() {
            document.querySelector(`.existingList[rtic_name='${this.title}']`).classList.remove("hidden");
        }

        hideRticLiseElement() {
            document.querySelector(`.existingList[rtic_name='${this.title}']`).classList.add("hidden");
        }
    }

    const companyLists = new CompanyLists();
    const exploreLists = new ExploreLists();
    const rtics = new Rtics();

    // Public functions
    return {
        pageBodyLoad: pageBodyLoad,
        findCompany: findCompany,
        toggleBoxView: toggleBoxView,
        companyLists: companyLists,
        exploreLists: exploreLists,
        setupUserguiding: setupUserguiding
    }
}();
